import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { NzTableModule } from "ng-zorro-antd/table";
import { HdDetailLinesPageComponent } from "./hd-detail-lines-page.component";

@NgModule({
  imports: [CommonModule, NzTableModule, DragDropModule],
  declarations: [HdDetailLinesPageComponent],
  exports: [HdDetailLinesPageComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class HdDetailLinesPageModule {}
